import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../api_config";
import UserContext from "../../Components/Authcontext";
import Load from "../Loading/Load";
import "./modern-forms.css";
import {
  fetchCasteOptions,
  fetchKulamOptions,
  fetchRaasiOptions,
  fetchStarOptions,
} from "../apis";

function ModernReligiousInformation() {
  const { user, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [religion, setReligion] = useState("");
  const [caste, setCaste] = useState("");
  const [Kulam, setKulam] = useState("");
  const [star, setStar] = useState("");
  const [raasi, setRaasi] = useState("");
  const [chevvai, setChevvai] = useState("");
  const [naga, setNaga] = useState("");
  const [raasiOptions, setRaasiOptions] = useState([]);
  const [starOptions, setStarOptions] = useState([]);
  const [casteOptions, setCasteOptions] = useState([]);
  const [kulamOptions, setKulamOptions] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(true);
  const navigate = useNavigate();

  // Define the form steps
  const totalSteps = 8;
  const currentStep = 7;

  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;

  useEffect(() => {
    fetchReligiousOptions();
  }, []);

  const fetchReligiousOptions = async () => {
    setLoadingOptions(true);
    try {
      // Fetch caste data directly with a more detailed approach
      let casteData = [];
      try {
        const casteResponse = await axios.get(`${API_BASE_URL}/api/caste`);
        console.log('Direct caste API response:', casteResponse.data);
        
        // Handle different possible response structures
        if (Array.isArray(casteResponse.data)) {
          casteData = casteResponse.data;
        } else if (casteResponse.data && typeof casteResponse.data === 'object') {
          // If it's an object with a data property
          casteData = casteResponse.data.data || casteResponse.data.castes || [];
        }
        
        // Manually create options if the structure is unexpected
        if (casteData.length === 0) {
          casteData = [
            { id: 1, castename: 'Brahmin' },
            { id: 2, castename: 'Kshatriya' },
            { id: 3, castename: 'Vaishya' },
            { id: 4, castename: 'Shudra' },
            { id: 5, castename: 'Scheduled Caste' },
            { id: 6, castename: 'Scheduled Tribe' },
            { id: 7, castename: 'Other' }
          ];
        }
        
        setCasteOptions(casteData);
      } catch (casteError) {
        console.error('Error fetching caste data:', casteError);
        // Fallback caste options
        setCasteOptions([
          { id: 1, castename: 'Brahmin' },
          { id: 2, castename: 'Kshatriya' },
          { id: 3, castename: 'Vaishya' },
          { id: 4, castename: 'Shudra' },
          { id: 5, castename: 'Scheduled Caste' },
          { id: 6, castename: 'Scheduled Tribe' },
          { id: 7, castename: 'Other' }
        ]);
      }
      
      // Fetch the other options
      const raasiData = await fetchRaasiOptions();
      const starData = await fetchStarOptions();
      const kulamData = await fetchKulamOptions();

      console.log('API Data:', { 
        raasiData, 
        starData, 
        casteData, 
        kulamData 
      });
      
      setRaasiOptions(raasiData);
      setStarOptions(starData);
      setKulamOptions(kulamData);
    } catch (error) {
      console.error('Error fetching religious options:', error);
    } finally {
      setLoadingOptions(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await axios.post(
      `${API_BASE_URL}/api/ReligiousInformation`,
      {
        user,
        religion,
        caste,
        Kulam,
        star,
        raasi,
        chevvai,
        naga,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    if (response.data.auth) {
      setLoading(false);
      navigate("/modern-partner-preference-info", { replace: true });
      setReligion("");
      setCaste("");
      setKulam("");
      setStar("");
      setRaasi("");
      setChevvai("");
      setNaga("");
    }
  };

  return loading ? (
    <Load />
  ) : (
    <div className="profile-form-container">
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
      <div className="decoration decoration-4"></div>
      <div className="profile-form-card">
        {/* Form Header with Progress Bar */}
        <div className="profile-form-header">
          <div className="progress-container">
            <div className="progress-steps">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} className="progress-step">
                  <div
                    className={`step-number ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 < currentStep ? "\u2713" : i + 1}
                  </div>
                  <div
                    className={`step-label ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 === 1 && "Basic Info"}
                    {i + 1 === 2 && "Contact"}
                    {i + 1 === 3 && "Personal"}
                    {i + 1 === 4 && "Photos"}
                    {i + 1 === 5 && "Family"}
                    {i + 1 === 6 && "Lifestyle"}
                    {i + 1 === 7 && "Religious"}
                    {i + 1 === 8 && "Preferences"}
                  </div>
                </div>
              ))}
              <div className="progress-line">
                <div
                  className="progress-line-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <h2 className="profile-form-title">Religious Information</h2>
          <p className="profile-form-subtitle">Tell us about your religious background</p>
          <p className="required-fields-note">All fields are mandatory</p>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit}>
          <div className="profile-form-body">
            <div className="form-group">
              <label className="form-label">Religion</label>
              <select
                className="form-control"
                value={religion}
                onChange={(e) => setReligion(e.target.value)}
                required
              >
                <option value="">Select religion</option>
                <option value="Hindu">Hindu</option>
                <option value="Muslim">Muslim</option>
                <option value="Christian">Christian</option>
                <option value="Sikh">Sikh</option>
                <option value="Buddhist">Buddhist</option>
                <option value="Jain">Jain</option>
                <option value="Parsi">Parsi</option>
                <option value="Jewish">Jewish</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Caste</label>
                  <select
                    className="form-control"
                    value={caste}
                    onChange={(e) => setCaste(e.target.value)}
                    required
                  >
                    <option value="">Select caste</option>
                    {loadingOptions ? (
                      <option disabled>Loading options...</option>
                    ) : (
                      casteOptions.map((option) => {
                        const id = option.id || option.casteid || option.caste_id || Math.random().toString();
                        const value = option.castename || option.name || option.caste || '';
                        return (
                          <option key={id} value={value}>
                            {value}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Kulam</label>
                  <select
                    className="form-control"
                    value={Kulam}
                    onChange={(e) => setKulam(e.target.value)}
                    required
                  >
                    <option value="">Select kulam</option>
                    {loadingOptions ? (
                      <option disabled>Loading options...</option>
                    ) : (
                      kulamOptions.map((option) => {
                        // Handle different possible data structures
                        const id = option.id || option.kulamid || option.kulam_id || Math.random().toString();
                        const value = option.kulam || option.name || '';
                        return (
                          <option key={id} value={value}>
                            {value}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Star</label>
                  <select
                    className="form-control"
                    value={star}
                    onChange={(e) => setStar(e.target.value)}
                    required
                  >
                    <option value="">Select star</option>
                    {loadingOptions ? (
                      <option disabled>Loading options...</option>
                    ) : (
                      starOptions.map((option) => {
                        // Handle different possible data structures
                        const id = option.id || option.natchaid || option.star_id || Math.random().toString();
                        const value = option.natchaname || option.name || option.star || '';
                        return (
                          <option key={id} value={value}>
                            {value}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Raasi</label>
                  <select
                    className="form-control"
                    value={raasi}
                    onChange={(e) => setRaasi(e.target.value)}
                    required
                  >
                    <option value="">Select raasi</option>
                    {loadingOptions ? (
                      <option disabled>Loading options...</option>
                    ) : (
                      raasiOptions.map((option) => {
                        // Handle different possible data structures
                        const id = option.id || option.rasiid || option.raasi_id || Math.random().toString();
                        const value = option.rasiname || option.name || option.raasi || '';
                        return (
                          <option key={id} value={value}>
                            {value}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Chevvai Dosham</label>
                  <select
                    className="form-control"
                    value={chevvai}
                    onChange={(e) => setChevvai(e.target.value)}
                    required
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Don't Know">Don't Know</option>
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Naga Dosham</label>
                  <select
                    className="form-control"
                    value={naga}
                    onChange={(e) => setNaga(e.target.value)}
                    required
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="Don't Know">Don't Know</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Form Footer with Buttons */}
          <div className="profile-form-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={() => navigate("/modern-habits-info")}
            >
              Back
            </button>
            <button type="submit" className="btn btn-primary">
              Save & Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModernReligiousInformation;
